/** Envelope every Travela backend (Laravel and Python) wraps a response in. */
export interface IApiResponse<T> {
  success: boolean;
  message: string;
  data: T;
  pagination?: IApiPagination | null;
}

interface IApiPagination {
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
}

/** A failed request: HTTP status (0 when no response arrived) and the backend's message. */
export class ApiError extends Error {
  readonly status: number;
  readonly details: unknown;

  constructor(status: number, message: string, details?: unknown) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.details = details;
  }
}
